import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'form-hint',
  templateUrl: './form-hint.component.html',
  styleUrls: ['./form-hint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormHintComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
